import { Box, Flex, Text } from "@chakra-ui/react";
import { AvatarImage } from "@verivest/shared-components";
import { ManagerContactModal } from "@verivest/shared-components/src/components/manager-profile/modals/ManagerContactModal";
import React from "react";
import { OpportunitySecurityCard } from "../OpportunitySecurityCard";
import { OpportunityRightSideProps } from "./OpportunityRightSide.types";

export const OpportunityRightSide: React.FC<OpportunityRightSideProps> = ({
  manager,
  isPreview,
  opportunity,
}) => {
  return (
    <>
      <OpportunitySecurityCard
        isPreview={isPreview}
        opportunity={opportunity}
      />
      {/* TODO: figure if we need it */}
      {manager.managerContact && (
        <Box mt="32px">
          <Flex>
            <AvatarImage
              h="48px"
              w="48px"
              minWidth="48px"
              minHeight="48px"
              image={manager.managerContact.imgUrl || ""}
            />
            <Box width="100%" ml="10px">
              <Text as="span">
                Sponsored by:{" "}
                <Text fontWeight="500" as="span">
                  {manager.name}
                </Text>
              </Text>
              <ManagerContactModal
                justAuthenticated
                managerId={manager.id || ""}
                profile={manager.managerContact}
                subject={"Inquiry about the investment opportunity"}
                message={`Hello, I have a question about ${opportunity.name}.`}
              >
                <Text color="brand.main" fontWeight="500" cursor="pointer">
                  Contact investment manager
                </Text>
              </ManagerContactModal>
            </Box>
          </Flex>
        </Box>
      )}
    </>
  );
};
